var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"mr-2 mt-1"},[_vm._v("Entries")]),_c('b-form-select',{attrs:{"value":_vm.perPage,"options":['50', '100', '250', 'All']},on:{"change":_vm.handleEntries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }